import { DetailEditEntityDialog } from '@/features/shared/components/entityDetails/DetailEditEntityDialog';
import { testRunStatusOptions } from '@/shared/constants/statusOptions';
import type { TagColor } from '@/shared/data/tags';
import type { TestRunDto } from '@flowqa/shared';
import type { ReactElement } from 'react';

type TestRunEditDialogProps = {
  open: boolean;
  execution: TestRunDto | null;
  loading?: boolean;
  onClose: () => void;
  onSave: (input: {
    tags: string[];
    colors: TagColor[];
    status?: TestRunDto['status'];
    timestamp?: Date | null;
    durationMs?: number | null;
  }) => Promise<void> | void;
};

export const TestRunEditDialog = ({
  open,
  execution,
  loading = false,
  onClose,
  onSave,
}: TestRunEditDialogProps): ReactElement => {
  const title = execution?.testName?.trim() ?? execution?.name?.trim() ?? execution?.id ?? '';

  return (
    <DetailEditEntityDialog
      open={open}
      entityLabel="Test Run"
      entityName={title}
      projectId={execution?.projectId ?? null}
      tags={execution?.tags ?? []}
      status={execution?.status}
      timestamp={execution?.timestamp ?? null}
      durationMs={execution?.durationMs ?? null}
      durationLabel="Duration"
      durationInputMode="timeParts"
      statusOptions={testRunStatusOptions}
      loading={loading}
      cascadeCopy="Tags will be applied only to this test run."
      onClose={onClose}
      onSave={onSave}
    />
  );
};
